import fr from './fr.json';
import en from './en.json';

export default {
  en,
  fr,
};
